import { NgClass, NgStyle } from "@angular/common";
import { Component, Input, OnInit, inject } from "@angular/core";
import { MatDivider } from "@angular/material/list";
import { ClassDirective, StyleDirective } from "@ngbracket/ngx-layout/extended";
import { FlexDirective, LayoutDirective } from "@ngbracket/ngx-layout/flex";
import { BusyIndicatorComponent, LabeledFieldComponent, TruncateTextComponent } from "@tylertech/common-components-module";
import { ExecutionResult, ICardAction, ICardData, ICardDataElement } from "@tylertech/tyler-api-types";
import { DetailDialogService } from "../../services";

const enum CardDataElementType
{
    TableHeader = "TableHeader",
    Row = "Row",
}

@Component({
    selector: "details",
    templateUrl: "./details.tmpl.html",
    styleUrls: [
        "./details.component.scss"
    ],
    imports: [
        BusyIndicatorComponent,
        ClassDirective,
        FlexDirective,
        LayoutDirective,
        StyleDirective,
        LabeledFieldComponent,
        MatDivider,
        NgClass,
        NgStyle,
        TruncateTextComponent,
    ],
    providers: [DetailDialogService]
})
export class DetailsComponent implements OnInit
{
    private readonly $detailDialogService = inject(DetailDialogService);

    @Input() cardActions: ICardAction[];
    @Input() detailUrl: string;
    @Input() model: unknown;
    @Input() color: string;

    colorClass: string;
    details: Array<ICardData>;
    isLoaded: boolean;

    ngOnInit(): void
    {
        // TODO - CSS Classes with the `md-` prefix probably came from Angularjs Material, This needs to be changes to either a locally defined CSS class or to a new source
        this.colorClass = "tyl-color-" + this.color;

        this.$detailDialogService.getDetail(this.detailUrl, this.model)
            .then((executionResult: ExecutionResult<Array<ICardData>>) =>
            {
                this.details = executionResult.Result;
            })
            .finally(() =>
            {
                this.isLoaded = true;
            });
    }

    getDataAlignStyle(data: string): Record<string, string>
    {
        const numericData = parseFloat(data.replace(/[$(),]/, ""));
        /* eslint-disable @typescript-eslint/naming-convention */
        return {
            "text-align": isNaN(numericData) ? "left" : "right",
        };
        /* eslint-enable @typescript-eslint/naming-convention */
    }

    getHeaderAlignStyle(index: number): Record<string, string> | undefined
    {
        const rows = this.details[0].DataElements.filter(x => x.Type === "Row");
        if (rows)
        {
            let i = 0;
            let data = rows[i].Value.split("|")[index];
            while (!data && i < rows.length - 1)
            {
                i++;
                data = rows[i].Value.split("|")[index];
            }
            if (data)
            {
                return this.getDataAlignStyle(data);
            }
        }
        return undefined;
    }

    getLabelParts(element: ICardDataElement): Array<string>
    {
        return element.Label.split("|");
    }

    getValueParts(element: ICardDataElement): Array<string>
    {
        return element.Value.split("|");
    }

    getVisibleDataElements(cardData: ICardData): Array<ICardDataElement>
    {
        return cardData.DataElements.filter(
            x => x.Type !== CardDataElementType.TableHeader && x.Type !== CardDataElementType.Row && x.Visible
        );
    }

    getVisibleHeaderElements(cardData: ICardData): Array<ICardDataElement>
    {
        return cardData.DataElements.filter(x => x.Type === CardDataElementType.TableHeader && x.Visible);
    }

    getVisibleRowElements(cardData: ICardData): Array<ICardDataElement>
    {
        return cardData.DataElements.filter(x => x.Type === CardDataElementType.Row && x.Visible);
    }
}
